// extracted by mini-css-extract-plugin
export default {"scriptBox":"ScriptBox_scriptBox__7GcI5","msg":"ScriptBox_msg__ocjEX","h3":"ScriptBox_h3__PrFCu","chatIcon":"ScriptBox_chatIcon__vxQw0"};